import { pluralize } from '../../utils';
import { Link } from 'react-router';
import styles from './project-sharing.module.less';
import Notification from '../../components/notification/Notification';
import VisibleIf from '../../components/VisibleIf';
import { sharingSteps } from './ProjectSharing';
import { ProjectSharingHeader } from './ProjectSharingHeader';

const MinifiedSharingStep = ({ children, url, completed }) => {
    const checkmarkClass = completed ? styles.checkmark : styles.checkmarkNotComplete;
    return (
        <Link className={styles.sharingStepContainer} to={url}>
            <div className={styles.sharingStatus}>
                <i className={`fa-solid fa-2x fa-circle-check ${checkmarkClass}`} aria-hidden="true" />
            </div>
            <div className={styles.sharingContent}>{children}</div>
        </Link>
    );
};

const MinifiedSharingSteps = ({ projectId, sharingProgress, showStreamLabs }) => {
    const customUrlComplete = sharingProgress[sharingSteps.customUrl] === true;
    const facebookComplete = sharingProgress[sharingSteps.facebook] === true;
    const instagramComplete = sharingProgress[sharingSteps.instagram] === true;
    const friendsComplere = sharingProgress[sharingSteps.friends] === true;
    const communityComplete = sharingProgress[sharingSteps.community] === true;
    const streamlabsComplete = sharingProgress[sharingSteps.streaming] === true;

    return (
        <div className={styles.sharingSteps}>
            <MinifiedSharingStep url={`/project/${projectId}/sharing/1`} completed={customUrlComplete}>
                Lag en personlig lenke
            </MinifiedSharingStep>
            <MinifiedSharingStep url={`/project/${projectId}/sharing/2`} completed={facebookComplete}>
                Del på Facebook
            </MinifiedSharingStep>
            <MinifiedSharingStep url={`/project/${projectId}/sharing/3`} completed={friendsComplere}>
                Send til støttespillere
            </MinifiedSharingStep>
            <MinifiedSharingStep url={`/project/${projectId}/sharing/4`} completed={communityComplete}>
                Del i grupper og fellesskap
            </MinifiedSharingStep>
            <MinifiedSharingStep url={`/project/${projectId}/sharing/5`} completed={instagramComplete}>
                Del på Instagram
            </MinifiedSharingStep>
            {showStreamLabs ? (
                <MinifiedSharingStep url={`/project/${projectId}/sharing/6`} completed={streamlabsComplete}>
                    Del på din stream
                </MinifiedSharingStep>
            ) : null}
        </div>
    );
};

export const ProjectSharingSummaryPanel = ({ stepsMissing, sharingProgress, project, showStreamLabs }) => {
    return (
        <>
            <ProjectSharingHeader
                title="Delingspanel"
                backLink={`/project/${project.id}/control`}
                backLinkText="Til kontrollpanel"
            />

            <p>
                For innsamlingen <em>{project.title}</em>
            </p>

            <p>Det er flere ting du kan gjøre for at innsamlingen din når flest mulig. Gå gjennom punktene under.</p>
            <VisibleIf isVisible={stepsMissing > 0}>
                <div>
                    Du har <Notification>{stepsMissing}</Notification>{' '}
                    {pluralize(stepsMissing, 'aktivitet', 'aktiviteter')} som gjenstår
                </div>
            </VisibleIf>
            <MinifiedSharingSteps
                projectId={project.id}
                sharingProgress={sharingProgress}
                showStreamLabs={showStreamLabs}
            />
        </>
    );
};
